<script>
import KpiMonitoring from "../KPIsMetrics/KpiMonitoring.vue";
import { mapActions } from "vuex/dist/vuex.common.js";

export default {
  components: {
    KpiMonitoring,
    /* TargetsTab */
  },

  data() {
    return {
      /* activeTab: "metrics" */

      suppliers: [],
      selectedSupplier: null,
      searchInput: '',
    }
  },

  computed: {
    filterCompaniesBySearchInput() {
      if (!this.searchInput || this.searchInput == '')
        return this.suppliers;
      else {
        return this.suppliers.filter(item => item.company_name.toLowerCase().includes(this.searchInput.toLowerCase()));
      }
    },
  },

  mounted() {
    this._getSuppliers();
  },

  methods: {
    /* changeTab(tab) {
      this.activeTab = tab;
    }, */

    ...mapActions('supplier', [
      'getSuppliers',
    ]),

    _getSuppliers() {
      this.getSuppliers()
        .then(res => {
          this.suppliers = res.data.value;
        })
    },

    setSelectedSupplier(item) {
      this.selectedSupplier = item;
    },

    goToMetricRequests() {
      this.$router.push('/admin-panel/supplier-metric-requests?parent=2');
    },
  }
}
</script>

<template>
  <div class="supplier-metrics-page">

    <div class="selection-page" v-if="selectedSupplier == null">
      <div class="selection-toolbar">
        <div class="search-container">
          <i class="fa-solid fa-magnifying-glass search-icon"></i>
          <input type="text" :placeholder="$t('supplierMetrics.metrics.search')" v-model="searchInput">
        </div>

        <div class="toolbar-actions">
          <button type="button" class="pill-button" @click="clickTotalMetrics()">
            <span>{{ $t("supplierMetrics.metrics.total") }}</span>
            <i class="fa-solid fa-chevron-right"></i>
          </button>
          <button type="button" class="pill-button pill-button--primary" @click="goToMetricRequests()">
            <i class="fa-solid fa-clipboard-list"></i>
            <span>{{ $t("supplierMetrics.metrics.go_to_requests") }}</span>
          </button>
        </div>
      </div>

      <div class="suppliers-grid">
        <button type="button" class="supplier-card" v-for="(item, index) in filterCompaniesBySearchInput" :key="index"
          @click="setSelectedSupplier(item)">
          <span class="supplier-card__name">{{ item.company_name }}</span>
          <i class="fa-solid fa-chevron-right"></i>
        </button>
      </div>
    </div>

    <kpi-monitoring v-if="selectedSupplier" :overrideCompanyId="selectedSupplier.company_id" />

    <!-- <div class="tabs-bar flex-all-centered-row">
          <div class="report-sections-bar tab col-6 text-center" @click="changeTab('metrics')" :class="{'active-tab': activeTab === 'metrics'}">
            {{ $t("supplierMetrics.tabs.metrics") }}
          </div>
          <div class="section-texts-bar tab col-6 text-center" @click="changeTab('targets')" :class="{'active-tab': activeTab === 'targets'}">
            {{ $t("supplierMetrics.tabs.targets") }}
          </div>
        </div> -->

    <!-- <targets-tab v-if="activeTab === 'targets'"/> -->
  </div>
</template>

<style lang='scss' scoped>
/* .tabs-bar {
    margin-top: 1em;

    & > .tab {
      background-color: var(--sustainfinity-navy);
      color: white;
      font-weight: bold;
      padding: .33em;
      cursor: pointer;
    
    }
    & > .report-sections-bar {
      border: .2em solid var(--sustainfinity-navy);
      border-top-left-radius: 1em;
      border-bottom-left-radius: 1em;
    }
    & > .section-texts-bar { 
      border: .2em solid var(--sustainfinity-navy);
      border-top-right-radius: 1em;
      border-bottom-right-radius: 1em;
    }
    & > .active-tab {
      background-color: white !important;
      color: var(--sustainfinity-navy) !important;
    }
} */

.supplier-metrics-page {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.selection-page {
  width: 100%;
  border-radius: 1em;
  background-color: whitesmoke;
  padding: 2em;

  display: flex;
  flex-direction: column;
  gap: 2em;
}

/* ---- toolbar: search on the left, actions on the right ---- */

.selection-toolbar {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1em;
}

.search-container {
  position: relative;
  flex: 1 1 18em;
  min-width: 14em;
  max-width: 32em;

  > .search-icon {
    position: absolute;
    left: .25em;
    top: 50%;
    transform: translateY(-50%);
    color: var(--user-internal);
    pointer-events: none;
  }

  > input {
    width: 100%;
    background: 0;
    border: 0;
    outline: 0;
    border-bottom: thin solid var(--user-internal);
    padding: .5em .5em .5em 2em;

    &:focus {
      border-bottom: thin solid black;
    }
  }
}

.toolbar-actions {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: .75em;
}

/* ---- shared pill button (toolbar actions) ---- */

.pill-button {
  display: inline-flex;
  align-items: center;
  gap: .6em;
  border-radius: 2em;
  border: thin solid lightgray;
  box-shadow: 0 0 .3em .1em lightgray inset;
  background-color: white;
  padding: .75em 1.25em;
  cursor: pointer;
  transition: all 150ms;
  white-space: nowrap;

  &:hover {
    border-color: var(--sustainfinity-blue);
    box-shadow: 0 0 .3em .1em var(--sustainfinity-blue) inset;
    background-color: var(--sustainfinity-faded-blue);
  }

  &:active {
    outline: .1em solid var(--sustainfinity-blue);
  }

  &--primary {
    background-color: var(--sustainfinity-navy);
    color: whitesmoke;
    border-color: var(--sustainfinity-navy);
    box-shadow: none;

    &:hover {
      background-color: var(--sustainfinity-blue);
      border-color: var(--sustainfinity-blue);
      box-shadow: none;
      color: whitesmoke;
    }
  }
}

/* ---- responsive supplier grid ---- */

.suppliers-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(16em, 1fr));
  gap: 1em;
  width: 100%;
}

.supplier-card {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 1em;
  text-align: left;

  border-radius: 1em;
  border: thin solid lightgray;
  box-shadow: 0 0 .3em .1em lightgray inset;
  background-color: white;
  padding: 1em 1.25em;
  cursor: pointer;
  transition: all 150ms;

  > .supplier-card__name {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  > i {
    flex-shrink: 0;
    color: var(--sustainfinity-blue);
  }

  &:hover {
    border-color: var(--sustainfinity-blue);
    box-shadow: 0 0 .3em .1em var(--sustainfinity-blue) inset;
    background-color: var(--sustainfinity-faded-blue);
  }

  &:active {
    outline: .1em solid var(--sustainfinity-blue);
  }
}
</style>